import type { I18nMessage } from '~~/shared/workflows/i18nMessage'

/**
 * Renders an `I18nMessage` — a key + params a RUN persisted — in the reader's language (#61).
 *
 * The fallback is the whole point of the shape: runs executed before the key existed carry only
 * the rendered sentence, and there is nothing better to show for them than the sentence they were
 * written with. It is also what keeps a key added on the server but not yet in the locales from
 * rendering a raw `runs.fillDocument.draftName` path at a user.
 */
export function useI18nMessage() {
  const { t, te } = useI18n()

  function renderMessage(message: I18nMessage | null | undefined, fallback?: string | null): string {
    if (!message?.key) return fallback ?? ''
    if (!te(message.key)) return fallback ?? ''
    const params = message.params ?? {}
    // vue-i18n's `t(key, named, plural)`: the third argument selects the `singular | plural` form,
    // and it is only passed when the message actually declares a count.
    return typeof message.count === 'number'
      ? t(message.key, params, message.count)
      : t(message.key, params)
  }

  return { renderMessage }
}
